import { render } from "./PollFinish.vue?vue&type=template&id=0a2a74ab"
import script from "./PollFinish.vue?vue&type=script&lang=js"
export * from "./PollFinish.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__